<template>
    <div class="toast-container">
        <transition-group name="toast">
            <div v-for="toast in toasts" :key="toast.id" class="toast" :class="toast.type">
                <div class="toast-content">
                    <i v-if="toast.type === 'success'" class="fas fa-check-circle" style="width: 20px; height: 20px;"></i>
                    <i v-else-if="toast.type === 'error'" class="fas fa-times-circle" style="width: 20px; height: 20px;"></i>
                    <i v-else-if="toast.type === 'warning'" class="fas fa-exclamation-triangle" style="width: 20px; height: 20px;"></i>
                    <i v-else class="fas fa-info-circle" style="width: 20px; height: 20px;"></i>
                    <span>{{ toast.message }}</span>
                </div>
                <button @click="removeToast(toast.id)" class="toast-close">
                    <i class="fas fa-times" style="width: 16px; height: 16px;"></i>
                </button>
            </div>
        </transition-group>
    </div>
</template>

<script>
import { useToastStore } from '@/store/index';
import { storeToRefs } from 'pinia';

export default {
    name: 'BaseToast',
    setup() {
        const toastStore = useToastStore();
        const { toasts } = storeToRefs(toastStore);

        const removeToast = (id) => {
            toastStore.removeToast(id);
        };

        return {
            toasts,
            removeToast
        };
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1050;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 350px;
}

.toast {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    overflow: hidden;
    padding: 12px 16px;
    position: relative;
    transition: all 0.3s ease;
    border-left: 4px solid #64748b;
}

.toast.success {
    border-left-color: #10b981;
}

.toast.error {
    border-left-color: #ef4444;
}

.toast.warning {
    border-left-color: #f59e0b;
}

.toast.info {
    border-left-color: #3b82f6;
}

.toast-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.toast-content svg {
    color: #64748b;
    flex-shrink: 0;
}

.toast.success svg {
    color: #10b981;
}

.toast.error svg {
    color: #ef4444;
}

.toast.warning svg {
    color: #f59e0b;
}

.toast.info svg {
    color: #3b82f6;
}

.toast-content span {
    color: #1e293b;
    font-size: 14px;
    line-height: 1.4;
}

.toast-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    position: absolute;
    right: 8px;
    top: 8px;
    transition: color 0.2s ease;
    margin-left: 10px;
}

.toast-close:hover {
    color: #64748b;
}

/* Transitions */
.toast-enter-active,
.toast-leave-active {
    transition: all 0.3s ease;
}

.toast-enter-from {
    opacity: 0;
    transform: translateX(30px);
}

.toast-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
</style>